import React from "react";
import classNames from 'classnames';
import ModalBase from "../modals/ModalBase";
import PlansCompareFeatures from "./PlansCompareFeatures";

import "../../../assets/sass/components/plans/plan-modal.scss";

class ComparePlansModal extends ModalBase {
    
    renderBody = () => {
        const { onSelect, showButtons } = this.props;

        return (
            <PlansCompareFeatures onSelect={onSelect} showButtons={showButtons} />
        )
    };
    
    renderHeader = () => {}

    renderFooter = () => {}

    modalClassname = () => classNames("plan-modal plan-modal-compare", this.props.plan);

    static defaultProps = {
        size: "xxl",
        plan: "gold",
        footerText: "Platinum Membership offers all features",
        btnText: "Upgrade To Platinum",
        onSelect: console.log,
        showButtons: true
    };
}

export default ComparePlansModal;
